<template>
  <el-form-item :label="i18nt('designer.setting.showModal')">
    <el-switch v-model="optionModel.showModal"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"

  export default {
    name: "showModal-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// showModal-editor.vue?d722b66c